import __request__ from "routing/request";
export function satisfiesVersion(distribution, version) {
  return __request__("GET", `/system/searchVersion/satisfiesVersion/${distribution}`, null, { "version": version }, {
    "Accept": ["application/json"]
  });
}
